<template>
  <div class="filter-select">
    <button
      class="form-select"
      @click="$emit('toggle', filter.key)"
      :class="{ active: isOpen }"
      type="button"
    >
      {{ filter.label }}
      <span v-if="selectedValues.length > 0" class="badge badge--sm">
        {{ selectedValues.length }}
      </span>
    </button>
    <div v-if="isOpen" class="filter-select__dropdown">
      <div class="item select-all" @click="$emit('select-all', filter.key)">
        <div class="form-check">
          <input
            :type="isMultiSelect ? 'checkbox' : 'radio'"
            class="form-check-input"
            :checked="
              isMultiSelect
                ? selectedValues.length === 0
                : !selectedValues.length
            "
            readonly
          />
          <span class="form-check-label">{{ filter.allLabel }}</span>
        </div>
      </div>
      <div v-if="loading" class="item loading">
        <div class="form-check">
          <span class="form-check-label text-muted">
            <i class="icon icon-spinner icon-spin me-2"></i>
            Laden...
          </span>
        </div>
      </div>
      <div
        v-for="option in visibleOptions"
        :key="getOptionKey(option)"
        class="item"
      >
        <div class="form-check" @click="$emit('select', filter.key, option)">
          <input
            :type="isMultiSelect ? 'checkbox' : 'radio'"
            class="form-check-input"
            :checked="isOptionSelected(option)"
            readonly
          />
          <span class="form-check-label">
            {{ getOptionLabel(option) }}
            <span v-if="filter.type === 'hierarchical-multi'" class="ms-1">
              <i class="icon icon-chevron-right"></i>
            </span>
          </span>
        </div>

        <div
          v-if="
            isOptionSelected(option) &&
            option.children &&
            option.children.length
          "
        >
          <div
            v-for="child in getVisibleChildren(option.children)"
            :key="getOptionKey(child)"
            class="item"
            @click.stop="$emit('select', filter.key, child)"
          >
            <div class="form-check">
              <input
                type="checkbox"
                class="form-check-input"
                :checked="isOptionSelected(child)"
                readonly
              />
              <span class="form-check-label">{{ getOptionLabel(child) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterDropdown',
  props: {
    filter: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
    selectedValues: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMultiSelect() {
      return (
        this.filter.type === 'multi' ||
        this.filter.type === 'hierarchical-multi'
      );
    },
    visibleOptions() {
      const optionList = this.options;

      // Sort values
      if (this.filter.sortOptions) {
        if (
          optionList.length &&
          typeof optionList[0] === 'object' &&
          optionList[0].name
        ) {
          optionList.sort((a, b) =>
            a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }),
          );
        } else {
          optionList.sort((a, b) => String(a).localeCompare(String(b)));
        }
      }

      return optionList.filter((option) => {
        const isSelected = this.isOptionSelected(option);
        const hasCount = option.count !== undefined;
        const countGreaterThanZero = hasCount ? option.count > 0 : true;

        return isSelected || countGreaterThanZero;
      });
    },
    getOptionsSorted() {
      return this.options;
    },
  },
  emits: ['toggle', 'select', 'select-all'],
  methods: {
    getOptionKey(option) {
      return option.id || option.term_id || option.name || option.label;
    },
    getOptionLabel(option) {
      let label = option.name || option.label;

      label = label.replace(/&amp;/g, '&');

      return label;
    },
    isOptionSelected(option) {
      if (this.isMultiSelect) {
        const key = this.getOptionKey(option);
        return this.selectedValues.includes(key);
      } else {
        return (
          this.selectedValues.length > 0 && this.selectedValues[0] === option
        );
      }
    },
    getVisibleChildren(children) {
      if (!children || !Array.isArray(children)) {
        return [];
      }

      return children.filter((child) => {
        const isSelected = this.isOptionSelected(child);
        const hasCount = child.count !== undefined;
        const countGreaterThanZero = hasCount ? child.count > 0 : true;

        return isSelected || countGreaterThanZero;
      });
    },
  },
};
</script>
